'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var leftPad = require('left-pad');

var whilst = require('async/whilst');

var waterfall = require('async/waterfall');

var dagPB = require('ipld-dag-pb');

var UnixFS = require('ipfs-unixfs');

var DAGLink = dagPB.DAGLink;
var DAGNode = dagPB.DAGNode;

var multihashing = require('multihashing-async');

var Dir = require('./dir');

var persist = require('../utils/persist');

var toPull = require('async-iterator-to-pull-stream');

var pull = require('pull-stream/pull');

var onEnd = require('pull-stream/sinks/on-end');

var asyncMap = require('pull-stream/throughs/async-map');

var Bucket = require('hamt-sharding');

var hashFn = function hashFn(value) {
  return new Promise(function (resolve, reject) {
    multihashing(value, 'murmur3-128', function (err, hash) {
      if (err) {
        reject(err);
      } else {
        // Multihashing inserts preamble of 2 bytes. Remove it.
        // Also, murmur3 outputs 128 bit but, accidently, IPFS Go's
        // implementation only uses the first 64, so we must do the same
        // for parity..
        var justHash = hash.slice(2, 10);
        var length = justHash.length;
        var result = Buffer.alloc(length); // TODO: invert buffer because that's how Go impl does it

        for (var i = 0; i < length; i++) {
          result[length - i - 1] = justHash[i];
        }

        resolve(result);
      }
    });
  });
};

hashFn.code = 0x22; // TODO: get this from multihashing-async?

var defaultOptions = {
  hashFn: hashFn
};

var DirSharded =
/*#__PURE__*/
function (_Dir) {
  _inherits(DirSharded, _Dir);

  function DirSharded(props, _options) {
    var _this;

    _classCallCheck(this, DirSharded);

    var options = Object.assign({}, defaultOptions, _options);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(DirSharded).call(this, props, options));
    _this._bucket = Bucket(options);
    return _this;
  }

  _createClass(DirSharded, [{
    key: "put",
    value: function put(name, value, callback) {
      return _regeneratorRuntime.async(function put$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _regeneratorRuntime.awrap(this._bucket.put(name, value));

            case 3:
              return _context.abrupt("return", callback());

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", callback(_context.t0));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[0, 6]]);
    }
  }, {
    key: "get",
    value: function get(name, callback) {
      return _regeneratorRuntime.async(function get$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.t0 = callback;
              _context2.next = 4;
              return _regeneratorRuntime.awrap(this._bucket.get(name));

            case 4:
              _context2.t1 = _context2.sent;
              return _context2.abrupt("return", (0, _context2.t0)(null, _context2.t1));

            case 8:
              _context2.prev = 8;
              _context2.t2 = _context2["catch"](0);
              return _context2.abrupt("return", callback(_context2.t2));

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this, [[0, 8]]);
    }
  }, {
    key: "childCount",
    value: function childCount() {
      return this._bucket.leafCount();
    }
  }, {
    key: "directChildrenCount",
    value: function directChildrenCount() {
      return this._bucket.childrenCount();
    }
  }, {
    key: "onlyChild",
    value: function onlyChild(callback) {
      try {
        return callback(null, this._bucket.onlyChild());
      } catch (err) {
        return callback(err);
      }
    }
  }, {
    key: "eachChildSeries",
    value: function eachChildSeries(iterator, callback) {
      pull(toPull(this._bucket.eachLeafSeries()), asyncMap(function (child, cb) {
        iterator(child.key, child.value, cb);
      }), onEnd(callback));
    }
  }, {
    key: "flush",
    value: function flush(path, ipld, source, callback) {
      var _this2 = this;

      _flush(this._options, this._bucket, path, ipld, source, function (err, results) {
        if (err) {
          return callback(err);
        } else {
          _this2.multihash = results.cid.buffer;
          _this2.size = results.node.size;
        }

        callback(null, results);
      });
    }
  }]);

  return DirSharded;
}(Dir);

module.exports = createDirSharded;
module.exports.hashFn = hashFn;

function createDirSharded(props, _options) {
  return new DirSharded(props, _options);
}

function _flush(options, bucket, path, ipld, source, callback) {
  var children = bucket._children; // TODO: intromission

  var index = 0;
  var links = [];
  whilst(function () {
    return index < children.length;
  }, function (callback) {
    var child = children.get(index);

    if (child) {
      collectChild(child, index, function (err) {
        index++;
        callback(err);
      });
    } else {
      index++;
      callback();
    }
  }, function (err) {
    if (err) {
      callback(err);
      return; // early
    }

    haveLinks(links, callback);
  });

  function collectChild(child, index, callback) {
    var labelPrefix = leftPad(index.toString(16).toUpperCase(), 2, '0');

    if (Bucket.isBucket(child)) {
      _flush(options, child, path, ipld, null, function (err, _ref) {
        var cid = _ref.cid,
            node = _ref.node;

        if (err) {
          callback(err);
          return; // early
        }

        links.push(new DAGLink(labelPrefix, node.size, cid));
        callback();
      });
    } else {
      var value = child.value;
      var label = labelPrefix + child.key;
      links.push(new DAGLink(label, value.size, value.multihash));
      callback();
    }
  }

  function haveLinks(links, callback) {
    // go-ipfs uses little endian, that's why we have to
    // reverse the bit field before storing it
    var data = Buffer.from(children.bitField().reverse());
    var dir = new UnixFS('hamt-sharded-directory', data);
    dir.fanout = bucket.tableSize();
    dir.hashType = options.hashFn.code;
    waterfall([function (cb) {
      return DAGNode.create(dir.marshal(), links, cb);
    }, function (node, cb) {
      return persist(node, ipld, options, cb);
    }, function (_ref2, cb) {
      var cid = _ref2.cid,
          node = _ref2.node;
      var pushable = {
        path: path,
        size: node.size,
        multihash: cid.buffer
      };

      if (source) {
        source.push(pushable);
      }

      cb(null, {
        cid: cid,
        node: node
      });
    }], callback);
  }
}